import React from "react";
import "../Policy_global.css";

function Service() {
  return (
    <div className="window">
      <h1>서비스 이용약관</h1>
      <div className="title-text">제 1조 (목적)</div>
      <div className="content-text">
        본디(BONDI)(이하 ‘회사’)가 제공하는 댕친소 서비스를 이용해 주셔서
        감사합니다. 회사는 여러분이 다양한 인터넷과 모바일 서비스를 좀 더
        편리하게 이용할 수 있도록 회사 ‘댕친소계정 약관’(이하 '본 약관')을
        마련하였습니다. 본 약관은 댕친소계정 서비스를 이용하는 데 필요한 권리,
        의무 및 책임사항, 이용조건 및 절차 등 기본적인 사항을 규정하고 있으므로
        시간을 내서 주의 깊게 읽어주시기 바랍니다.
      </div>
      <div className="title-text">제 2조 (약관의 효력 및 변경)</div>
      <div className="content-text">
        회사가 필요하다고 판단할 경우, 회사는 본 서비스 목적의 범위 내에서 본
        약관을 변경할 수 있습니다. 이때 회사는 본 약관의 변경본의 내용과 변경의
        효력일을 본 서비스 또는 회사의 공지사항에 게시하거나, 이를 회사가 정한
        방법으로 회원에게 통지하여야 합니다. 본 약관의 변경본은 그 효력일로부터
        효력이 발생합니다.
      </div>
      <div className="title-text">제 3조 (약관 외 준칙)</div>
      <div className="content-text">
        본 약관에 규정되지 않은 사항에 대해서는 관련법령 또는 회사가 정한 개별
        서비스의 이용약관, 운영정책 및 규칙 등(이하 ‘세부지침’)의 규정에
        따릅니다.
      </div>
      <div className="title-text">제 4조 (용어의 정의)</div>
      <div className="content-text">
        1. 고객: 본 서비스에 회원 가입하기 이전의 이용자를 말합니다.
      </div>
      <div className="content-text">
        2. 댕친소계정: 회사 또는 관계사가 제공하는 개별 서비스를 하나의
        로그인계정과 비밀번호로 회원 인증, 회원정보 변경, 회원 가입 및 탈퇴 등을
        관리할 수 있도록 회사가 정한 로그인계정 정책을 말합니다.
      </div>
      <div className="content-text">
        3. 회원: 댕친소계정이 적용된 개별 서비스 또는 댕친소계정
        어플리케이션에서 본 약관에 동의하고, 댕친소계정을 이용하는 자를
        말합니다.
      </div>
      <div className="content-text">
        4. 관계사: 회사와 제휴 관계를 맺고 댕친소계정을 공동 제공하기로 합의한
        법인을 말합니다. 개별 관계사는 회사의 개인정보 취급방침에서 확인할 수
        있고 추후 추가/변동될 수 있으며 관계사가 추가/변동될 때에는 본 서비스의
        공지사항에 변경사항을 게시합니다.
      </div>
      <div className="content-text">
        5. 콘텐츠: 문장, 음성, 음악, 이미지, 동영상, 소프트웨어, 프로그램, 코드
        및 기타 정보를 말합니다.
      </div>
      <div className="content-text">
        6. 본 콘텐츠: 본 서비스를 통해 접속할 수 있는 콘텐츠를 말합니다.
      </div>
      <div className="content-text">
        7. 투고 콘텐츠: 회원이 본 서비스에 투고, 송신 또는 업로드한 콘텐츠를
        말합니다.
      </div>
      <div className="content-text">
        8. 발바닥: 본 서비스가 유상으로 제공하는 서비스 또는 콘텐츠와 교환
        가능한 선불 결제 수단 등을 말합니다.
      </div>
      <div className="content-text">
        9. 댕친소: 본 서비스에서 제공하는 소개팅 기능을 말합니다.
      </div>
      <div className="content-text">
        10. 댕시터: 본 서비스에서 제공하는 펫시터 기능을 말합니다.
      </div>
      <div className="content-text">
        11. 아나바다: 본 서비스에서 제공하는 중고장터 기능을 말합니다.
      </div>
      <div className="content-text">
        12. 댕스팟: 본 서비스에서 제공하는 동반가능 편의시설 정보 기능을
        말합니다.
      </div>
      <div className="content-text">
        13. 댕잘댕잘: 본 서비스에서 제공하는 커뮤니티 기능을 말합니다.
      </div>
      <div className="title-text">제 5조 (계약의 성립)</div>
      <div className="content-text">
        1. 댕친소계정 이용 신청은 어플리케이션의 회원가입 화면에서 댕친소계정
        정보에 일정 정보를 입력하는 방식으로 이루어집니다.
      </div>
      <div className="content-text">
        2. 댕친소계정 이용계약은 본 약관의 내용에 동의한 후 5,1 항에서 정한
        이용신청을 하면 회사가 입력된 일정 정보를 인증한 후 가입을 승낙함으로써
        체결됩니다.
      </div>
      <div className="title-text">제 6조 (댕친소계정의 이용제한)</div>
      <div className="content-text">
        1. 제 5조에 따른 가입 신청자에게 회사는 원칙적으로 댕친소 계정의 이용을
        승낙합니다. 다만, 회사는 아래 각 호의 경우에는 그 사유가 해소될 때까지
        승낙을 유보하거나 승낙하지 않을 수 있습니다.
      </div>
      <div className="content-text">
        a. 회사가 본 약관 또는 세부지침에 의해 댕친소계정을 삭제하였던 경우
      </div>
      <div className="content-text">
        b. 다른 사람의 명의나 이메일 주소 등 개인정보를 이용하여 댕친소계정을
        생성하려 한 경우
      </div>
      <div className="content-text">
        c. 댕친소계정 생성 시 필요한 정보를 입력하지 않거나 허위의 정보를 입력한
        경우
      </div>
      <div className="content-text">
        d. 제공 서비스 설비 용량에 현실적인 여유가 없는 경우
      </div>
      <div className="content-text">
        e. 서비스 제공을 위한 기술적인 부분에 문제가 있다고 판단되는 경우
      </div>
      <div className="content-text">
        f. 기타 회사가 재정적, 기술적으로 필요하다고 인정하는 경우
      </div>
      <div className="content-text">
        g. 회사로부터 회원자격정지 조치 등을 받은 회원이 그 조치기간에
        이용계약을 임의로 해지하고 재이용을 신청하는 경우
      </div>
      <div className="content-text">
        h. 기타 관련법령에 위배되거나 세부지침 등 회사가 정한 기준에 반하는 경우
      </div>
      <div className="content-text">
        i. 댕친소의 과거에 운영원칙 또는 법률 위반 등의 정당한 사유로 해당
        계정을 삭제 또는 징계한 경우
      </div>
      <div className="content-text">
        2. 위 조건에 위반하여 댕친소계정을 생성한 것으로 판명된 때에는 회사는
        즉시 댕친소계정 이용을 정지시키거나 댕친소계정을 삭제하는 등 적절한
        제한을 할 수 있습니다.
      </div>
      <div className="title-text">제 7조 (댕친소계정)</div>
      <div className="content-text">
        1. 본 서비스 이용을 위해 고객은 별다른 비밀번호 없이 휴대전화 번호만으로
        계정을 생성할 수 있습니다. 다만, 실제 휴대전화의 소유주임을 확인하기
        위해서 가입 당시 인증 절차를 거치게 됩니다. 또한, 다른 모바일 기기에서
        서비스 사용을 연속하기 위해서는 기존에 가입하고 인증했던 휴대전화 번호로
        재인증을 해야합니다. 아래의 경우에는 계정 생성을 승인하지 않을 수
        있습니다.
      </div>
      <div className="content-text">
        2. 본 서비스에 등록한 회원은 언제라도 계정을 삭제하고 탈퇴할 수
        있습니다.
      </div>
      <div className="content-text">
        3. 회사는 마지막 접속 시점부터 １년 이상 경과한 계정을 해당 회원에 대한
        사전 통지 없이 삭제할 수 있습니다.
      </div>
      <div className="content-text">
        4. 회원이 본 서비스에서 가지는 모든 이용 권한은 이유를 막론하고 계정이
        삭제된 시점에 소멸됩니다. 회원의 실수로 계정을 삭제한 경우에도 계정을
        복구할 수 없음에 유의하시기 바랍니다.
      </div>
      <div className="content-text">
        5. 본 서비스의 계정은 회원에게 일신전속적으로 귀속됩니다. 회원이 본
        서비스에서 가지는 모든 이용권은 제삼자에게 양도, 대여 또는 처분할 수
        없으며, 제삼자에게 상속 또는 승계될 수 없습니다.
      </div>
      <div className="title-text">제 8조 (댕친소계정 관리)</div>
      <div className="content-text">
        1. 회원은 서비스 내 댕친소계정 설정 화면을 통하여 댕친소계정 정보를
        열람하고 수정할 수 있습니다. 다만, 댕친소계정 서비스의 제공 및 관리를
        위해 필요한 댕친소계정, 전화번호, 단말기 식별번호, 기타 본인확인정보 등
        일부 정보는 수정이 불가능할 수 있으며, 수정하는 경우에는 추가적인 본인
        확인 절차가 필요할 수 있습니다. 이용 신청 시 알려주신 내용에 변동이 있을
        때, 직접 수정하시거나 이메일, 고객센터를 통하여 회사에 알려 주시기
        바랍니다.
      </div>
      <div className="content-text">
        2. 댕친소계정 정보를 적시에 수정하지 않아 발생하는 문제에 대하여 회사는
        책임을 부담하지 아니합니다.
      </div>
      <div className="title-text">제 9조 (프라이버시)</div>
      <div className="content-text">
        1. 회사는 회원의 프라이버시를 존중합니다.
      </div>
      <div className="content-text">
        2. 회사는 회원의 프라이버시 정보와 개인정보를 본디(BONDI) 개인정보
        취급방침에 따라 적절하게 취급합니다.
      </div>
      <div className="content-text">
        3. 회사는 회원으로부터 수집한 모든 정보를 안전하게 관리하기 위해 보안에
        최대한 주의를 기울이고 있습니다.
      </div>
      <div className="title-text">제 10조 (서비스 제공)</div>
      <div className="content-text">
        1. 회원은 본 서비스를 이용하는 데 있어 필요한 PC나 휴대전화 단말기,
        스마트폰 및 기타 통신 기기, 운영 체제, 통신 수단 및 전력 등을 회원의
        비용과 책임 하에 준비해야 합니다.
      </div>
      <div className="content-text">
        2. 회사는 본 서비스의 전부 또는 일부를 고객의 연령 및 본인 확인 여부,
        등록정보 유무 등 회사가 필요하다고 판단한 조건을 만족시키는 회원에
        한하여 제공할 수 있습니다.
      </div>
      <div className="content-text">
        3. 회사가 필요하다고 판단될 경우, 회원에 대한 사전 통지 없이 언제라도 본
        서비스의 전부 또는 일부 내용을 변경할 수 있습니다.
      </div>
      <div className="content-text">
        4. 회사는 다음 각 호의 경우 회원에 대한 사전 통지 없이 언제라도 본
        서비스의 전부 또는 일부의 제공을 중지할 수 있습니다.
      </div>
      <div className="content-text">
        a. 시스템을 유지보수 또는 수리하는 경우
      </div>
      <div className="content-text">
        b. 사고(화재, 정전 등), 천재지변, 전쟁, 폭동, 노동 쟁의 등 불가항력으로
        인해 본 서비스를 제공할 수 없는 경우
      </div>
      <div className="content-text">
        c. 시스템이 고장 나거나 심각한 부하가 걸리는 경우
      </div>
      <div className="content-text">
        d. 회원 또는 제삼자의 안전을 확보하거나 공공복리를 위한 비상사태의 경우
      </div>
      <div className="content-text">
        e. a 부터 d까지 명시된 사항 이외에 회사가 필요하다고 합리적으로 판단하는
        경우
      </div>
      <div className="title-text">제 11조 (긴급 신고 기능 미적용)</div>
      <div className="content-text">
        본 서비스는 경찰기관, 해상보안기관, 소방기관 기타 기관에 대한 긴급 신고
        수단을 제공하지 않습니다.
      </div>
      <div className="title-text">제 12조 (광고 게재)</div>
      <div className="content-text">
        회사는 본 서비스에 회사 또는 제삼자의 광고를 게재할 수 있습니다.
      </div>
      <div className="title-text">제 13조 (제휴 서비스) </div>
      <div className="content-text">
        본 서비스는 회사 이외의 제삼자가 제공하는 서비스 또는 콘텐츠를 포함할 수
        있습니다. 이러한 서비스 및/또는 콘텐츠에 대한 모든 책임은 이를 제공하는
        제삼자에게 있습니다. 또한, 이러한 서비스 및 콘텐츠에는 이를 제공하는
        제삼자가 정한 이용약관 기타 조건이 적용되는 경우가 있습니다.
      </div>
      <div className="title-text">제 14조 (콘텐츠) </div>
      <div className="content-text">
        1. 회사는 회사가 제공하는 본 콘텐츠에 대해 양도 및 재실시가 불가능하고
        비독점적이며 본 서비스의 이용을 유일한 목적으로 하는 이용권을 회원에게
        부여합니다.
      </div>
      <div className="content-text">
        2. 회원은 추가 이용료, 이용 기간 등의 이용 조건이 별도로 규정된 본
        콘텐츠를 이용할 경우, 이와 같은 이용 조건에 따라야 합니다. 본 서비스의
        화면에 ‘구입’, ‘판매’ 등이 표기되어 있을 경우에도 회사가 회원에게
        제공하는 본 콘텐츠에 관한 지식재산권 기타 권리는 회사가 보유하고
        회원에게 이전되지 않으며, 회원에게는 상기 이용권만이 부여됩니다.
      </div>
      <div className="content-text">
        3. 회원은 본 콘텐츠를 본 서비스에서 미리 정한 이용 형태를 넘어서
        이용(복제, 송신, 전재, 수정 등의 행위를 포함하나 이에 한정되지
        아니함)해서는 안 됩니다.
      </div>
      <div className="content-text">
        4. 회사는 투고 콘텐츠의 백업을 실시할 의무를 갖지 않습니다.
      </div>
      <div className="content-text">
        5. 회원은 투고 콘텐츠에 대해 보유하는 권리를 갖지 않습니다. 투고 콘텐츠
        중 다른 회원에게 일반적으로 공개되는 것(대화 내용, 팔로우, 팔로잉
        목록)에 한하여 회원은 해당 콘텐츠를 서비스 및/또는 프로모션에 이용할 수
        있는 권리(회사가 필요하고 적절하다고 판단한 범위 내에서 생략 등의 변경을
        가할 수 있는 권리 및 이러한 이용 권한을 회사가 제휴하는 제삼자에게
        재실시할 수 있는 권리를 포함함)를 회사에 부여하는 것으로 간주합니다.
      </div>
      <div className="content-text">
        6. 회원은 회사 또는 제삼자가 상기 제14조 5항에 따라 투고 콘텐츠를
        사용하는 것과 관련하여 저작인격권과 같은 권리를 행사해서는 안됩니다.
      </div>
      <div className="content-text">
        7. 회사는 관련 법령 또는 본 약관의 준수 상황 등을 확인할 필요가 있을
        경우, 법령이 허락하는 한도 내에서 회원의 투고 콘텐츠의 내용을 데이터
        베이스에서 확인할 수 있습니다. 단, 회사는 만일의 사태에 대비하여 투고
        컨텐츠를 보관할 뿐, 그런한 확인 작업을 실시할 의무를 가지는 것은
        아닙니다.
      </div>
      <div className="content-text">
        8. 회사는 회원이 투고 콘텐츠에 관하여 관련 법령 또는 본 약관을
        위반하거나 또는 위반할 우려가 있다고 판단한 경우 또는 기타 회사의 업무상
        필요한 경우, 회원에게 사전 통지 없이 투고 콘텐츠를 삭제하는 등의 방법을
        통하여 본 서비스에서 투고 콘텐츠를 이용하는 것을 제한할 수 있습니다.
      </div>
      <div className="title-text">제 15조 (발바닥)</div>
      <div className="content-text">
        발바닥은 본 서비스를 이용하기 위해 구입하거나 기타 회사가 지정한 방법을
        통해 회원에게 부여됩니다. 발바닥의 구입 단위, 결제 방법 및 기타 큐브의
        부여 조건은 회사가 정하여 본 서비스에 게재합니다. 발바닥은 회사가 지정한
        서비스 및 콘텐츠 이외의 현금, 재물 기타 경제적 이익과 교환 또는 사용할
        수 없습니다. 서비스 또는 콘텐츠 교환에 필요한 큐브 수는 본 서비스에
        게재합니다. 발바닥은 이를 취득한 계정에서만 이용 가능합니다. 또한 운영
        체제가 다른 단말기에서 제공되는 발바닥은 동일한 명칭이더라도 종류가
        다르므로 이관되거나 합산될 수 없습니다. 발바닥는 관련 법령이 정하는 바에
        따라 환불 될 수 있습니다. 이때 회사는 관련 법령에 따라 환불 절차를
        정하여야 하며, 본 서비스에서 이러한 정보를 이용할 수 있도록 하여야
        합니다.
      </div>
      <div className="title-text">제 16조 (댕친소)</div>
      <div className="content-text">
        댕친소에 작성한 모든 투고 컨텐츠는 일정 시간동안 모든 회원에게
        게재됩니다.
      </div>
      <div className="content-text">
        회원은 댕친소 올라온 어떠한 투고 컨텐츠에 대하여 보유권리를 갖고 있지
        않습니다,
      </div>
      <div className="title-text">제 17조 (금지사항)</div>
      <div className="content-text">
        회원은 본 서비스 이용중 다음에 기재된 행위를 해서는 안됩니다.
      </div>
      <div className="content-text">
        1. 법령, 법원의 판결, 결정 혹은 명령 또는 법령상 구속력을 가지는 행정
        조치에 위반되는 행위.
      </div>
      <div className="content-text">
        2. 공공질서 또는 미풍양속을 저해할 우려가 있는 행위.
      </div>
      <div className="content-text">
        3. 회사 및/또는 제삼자의 저작권, 상표권, 특허권 등의 지식재산권, 명예권,
        프라이버시권 및 기타 법령상 또는 계약상의 권리를 침해하는 행위.
      </div>
      <div className="content-text">
        4. 과도하게 폭력적인 표현, 노골적인 성적 표현, 아동 포르노나 아동 학대에
        해당하는 표현, 인종, 국적, 신조, 성별, 사회적 지위와 출신 가족 등에
        관하여 차별하는 표현, 자살, 자상 행위, 약물 남용을 유인 또는 조장하는
        표현 또는 기타 반사회적인 내용을 포함하고 타인에게 불쾌감을 주는 표현을
        투고 또는 송신하는 행위.
      </div>
      <div className="content-text">
        5. 회사의 관리자 또는 제삼자를 사칭하는 행위 또는 의도적으로 허위 정보를
        유포하는 행위.
      </div>
      <div className="content-text">
        6. 동일하거나 유사한 메시지를 불특정 다수의 회원에게 송신하는 행위, 기타
        회사가 스팸으로 판단한 행위
      </div>
      <div className="content-text">
        7. 회사가 정한 방법 외의 방법으로 본 서비스 또는 본 콘텐츠의 이용권을
        현금, 재물 기타 경제적 이익과 교환하는 행위.
      </div>
      <div className="content-text">
        8. 성적 행위와 외설적인 행위를 목적으로 본 서비스를 이용하는 행위,
        면식이 없는 제삼자와의 성적인 만남과 교제를 목적으로 본 서비스를
        이용하는 행위, 다른 회원에 대한 악의적인 행위나 비방 및 중상모략 등을
        목적으로 본 서비스를 이용하는 행위 또는 기타 본 서비스가 미리 정한 이용
        목적과 다른 목적으로 본 서비스를 이용하는 행위.
      </div>
      <div className="content-text">
        9. 타인의 개인정보, 등록 정보, 사용자 이력 등을 불법으로 수집, 공개 또는
        제공하는 행위.
      </div>
      <div className="content-text">
        10. 본 서비스의 서버 및/또는 네트워크 시스템에 지장을 주는 행위,
        봇(bot), 치팅 툴 또는 기타 기술적인 수단을 이용하여 본 서비스를 불법으로
        조작하는 행위, 본 서비스의 장애를 의도적으로 이용하는 행위, 동일한
        질문을 필요 이상으로 반복하는 등 회사에 대해 부당한 문의 및/또는 요구를
        하는 행위 및 기타 회사의 본 서비스 운영 또는 다른 회원의 본 서비스
        이용을 방해하거나 이에 지장을 주는 행위.
      </div>
      <div className="content-text">
        11. 자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가할
        목적으로 허위의 정보를 유통시키는 행위
      </div>
      <div className="content-text">
        12. 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램
        포함)의 전송 또는 게시 행위
      </div>
      <div className="content-text">
        13. 회사 또는 관계사의 직원이나 운영자를 가장하거나 사칭하여 또는 타인의
        명의를 도용하여 글을 게시하거나 E-mail, 댕친소 메시지 등을 발송하는 행위
      </div>
      <div className="content-text">
        14. 상기 1항부터 13항까지의 어느 하나에 해당되는 행위를 원조 또는
        조장하는 행위.
      </div>
      <div className="content-text">
        15. 기타 부적당하다고 회사가 합리적으로 판단한 행위
      </div>
      <div className="title-text">제 18조 (회원의 책임 및 의무)</div>
      <div className="content-text">
        1. 회원은 회원 자신의 책임 하에 본 서비스를 이용해야 하며, 본 서비스의
        이용에 따라 이루어진 모든 행위 및 그 결과에 대해서 일체의 책임을 져야
        합니다
      </div>
      <div className="content-text">
        2. 회사는 해당 회원이 다음 각 호의 어느 하나에 속하거나 속할 가능성이
        있는 경우, 해당 회원에 대한 사전 통지 없이 본 서비스의 전부 또는 일부의
        사용을 중지하거나, 계정을 정지 또는 삭제하거나, 본 서비스와 관련한
        회사와 회원 간의 모든 계약(본 약관에 근거한 계약을 포함하나 이에
        한정되지 아니함)을 해지하거나, 회사가 필요하며 적절하다고 합리적으로
        판단한 기타 조치를 취할 수 있습니다.
      </div>
      <div className="content-text">
        a. 회원이 관련 법령, 본 약관 또는 개별 이용약관을 위반하는 경우
      </div>
      <div className="content-text">
        b. 회원이 허위 정보를 유포하거나, 부정한 방법 기타 불법적인 수단을
        사용하여 회사의 신용을 훼손하는 경우
      </div>
      <div className="content-text">
        c. a, b까지 명시된 것 이외의 사유로 인하여 회원과의 신뢰 관계가
        상실되거나 기타 회사가 본 서비스를 회원에게 제공하는 것이 적절하지
        않다고 합리적으로 판단하는 경우
      </div>
      <div className="content-text">
        d. 회원이 본 서비스 이용에 기인하여(회사가 이러한 이용으로 인해
        제삼자로부터 클레임을 받은 경우를 포함하나 이에 한정되지 아니함) 회사가
        직접적 혹은 간접적으로 어떤 손해(변호사 비용 부담을 포함하나 이에
        한정되지 아니함)를 입었을 경우, 회원은 회사의 요구에 따라 즉시 이를
        보상해야 합니다
      </div>
      <div className="title-text">제 19조 (보증의 미제공)</div>
      <div className="content-text">
        회사는 본 서비스(본 콘텐츠를 포함)와 관련하여 하자(보안 등에 관련된
        결함, 오류와 버그, 권리 침해 등을 포함하나 이에 한정되지 아니함)가
        없다는 점 및 안전성, 신뢰성, 정확성, 완전성, 유효성 및 특정 목적과의
        적합성을 명시적 또는 암묵적으로 보증하지 않습니다. 회사는 회원에 대해
        이러한 하자를 제거하고 본 서비스를 제공할 의무를 갖지 않습니다.
      </div>
      <div className="title-text">제 20조 (손해배상)</div>
      <div className="content-text">
        1. 회사는 법령상 허용되는 한도 내에서 서비스와 관련하여 본 약관에
        명시되지 않은 어떠한 구체적인 사항에 대한 약정이나 보증을 하지 않습니다.
        또한, 회사는 CP(divs Provider)가 제공하거나 회원이 작성하는 등의
        방법으로 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해서는
        보증을 하지 않으며, 회사의 과실 없이 발생된 손해에 대하여는 책임을
        부담하지 아니합니다.
      </div>
      <div className="content-text">
        2. 회사는 회사의 과실로 인하여 손해를 입게 될 경우 본 약관 및 관련
        법령에 따라 손해를 배상하겠습니다. 다만 회사는 회사의 과실 없이 발생된
        아래와 같은 손해에 대해서는 책임을 부담하지 않습니다. 또한 회사는 법률상
        허용되는 한도 내에서 간접 손해, 특별 손해, 결과적 손해, 징계적 손해, 및
        징벌적 손해에 대한 책임을 부담하지 않습니다.
      </div>
      <div className="content-text">
        a. 천재지변 또는 이에 준하는 불가항력의 상태에서 발생한 손해
      </div>
      <div className="content-text">
        b. 회원의 귀책사유로 서비스 이용에 장애가 발생한 경우
      </div>
      <div className="content-text">
        c. 서비스에 접속 또는 이용과정에서 발생하는 개인적인 손해
      </div>
      <div className="content-text">
        d. 제3자가 불법적으로 회사의 서버에 접속하거나 서버를 이용함으로써
        발생하는 손해
      </div>
      <div className="content-text">
        e. 제3자가 회사 서버에 대한 전송 또는 회사 서버로부터의 전송을
        방해함으로써 발생하는 손해
      </div>
      <div className="content-text">
        f. 제3자가 악성 프로그램을 전송 또는 유포함으로써 발생하는 손해
      </div>
      <div className="content-text">
        g. 전송된 데이터의 생략, 누락, 파괴 등으로 발생한 손해, 명예훼손 등
        제3자가 서비스를 이용하는 과정에서 발생된 손해
      </div>
      <div className="content-text">
        h. 기타 회사의 고의 또는 과실이 없는 사유로 인해 발생한 손해
      </div>
      <div className="title-text">제 21조 (연락 방법)</div>
      <div className="content-text">
        회사는 여러분과의 의견 교환을 소중하게 생각합니다. 언제든지 서비스의
        건의사항에 방문하여 의견을 개진할 수 있습니다. 서비스 이용자 전체에 대한
        공지는 공지사항란에 게시함으로써 효력이 발생합니다. 회원들에게 중대한
        영향을 미치는 사항의 경우에는 댕친소계정에 등록된 이메일 주소로
        이메일(이메일주소가 없는 경우 서비스 내 전자쪽지 발송, 서비스 내 알림
        메시지를 띄우는 등의 별도의 전자적 수단) 발송 또는 회원이 등록한
        휴대폰번호로 문자메시지 발송하는 방법 등으로 개별적으로 알려
        드리겠습니다.
      </div>
      <div className="title-text">제 22조 (분쟁의 해결)</div>
      <div className="content-text">
        본 약관 또는 서비스는 대한민국법령에 의하여 규정되고 이행됩니다. 서비스
        이용과 관련하여 회사와 회원 간에 분쟁이 발생하면 이의 해결을 위해 성실히
        협의할 것입니다. 그럼에도 불구하고 해결되지 않으면 민사소송법상의
        관할법원에 소를 제기할 수 있습니다.
      </div>
      <div className="content-text">공고일자 : 2022년 5월 30일</div>
      <div className="content-text">시행일자 : 2022년 5월 30일</div>
    </div>
  );
}

export default Service;
